"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reducer = exports.initialState = void 0;
const types_1 = require("../types");
const types_2 = require("./actions/types");
const dummies = {
    newItem: false,
    newLoyalty: false,
    newError: false,
};
const initialState = Object.assign(Object.assign({}, dummies), { loading: false });
exports.initialState = initialState;
function reducer(baseState, action) {
    const state = Object.assign(Object.assign({}, baseState), { loading: false });
    switch (action.type) {
        case types_2.ActionTypes.REQUEST:
            return Object.assign(Object.assign(Object.assign(Object.assign({}, state), { params: action.payload }), dummies), { loading: true });
        case types_2.ActionTypes.ADD_ITEM_CART:
        case types_2.ActionTypes.REOPEN_CART:
            if (action.payload.status === types_1.ResponseCode.ONBOARDING_REDIRECT) {
                return Object.assign(Object.assign({}, state), { error: {} });
            }
            return Object.assign(Object.assign(Object.assign(Object.assign({}, state), { error: {} }), action.payload), { newItem: true });
        case types_2.ActionTypes.ADD_LOYALTY:
            return Object.assign(Object.assign(Object.assign(Object.assign({}, state), { error: {} }), action.payload), { newLoyalty: true });
        case types_2.ActionTypes.GET_CART:
            return Object.assign(Object.assign(Object.assign({}, state), { error: {} }), action.payload);
        case types_2.ActionTypes.CANCEL_RECOVER_CART:
        case types_2.ActionTypes.DEFROST_CART:
        case types_2.ActionTypes.DELETE_CART:
        case types_2.ActionTypes.FREEZE_CART:
        case types_2.ActionTypes.RECOVER_EXPIRED_CART:
        case types_2.ActionTypes.REMOVE_ITEM_CART:
        case types_2.ActionTypes.REMOVE_LOYALTY:
        case types_2.ActionTypes.GET_DETAILED_CART:
        case types_2.ActionTypes.ADD_ITEM_CART_FAILED:
        case types_2.ActionTypes.CANCEL_RECOVER_CART_FAILED:
        case types_2.ActionTypes.DEFROST_CART_FAILED:
        case types_2.ActionTypes.DELETE_CART_FAILED:
        case types_2.ActionTypes.FREEZE_CART_FAILED:
        case types_2.ActionTypes.GET_CART_FAILED:
        case types_2.ActionTypes.RECOVER_EXPIRED_CART_FAILED:
        case types_2.ActionTypes.REMOVE_ITEM_CART_FAILED:
        case types_2.ActionTypes.ADD_LOYALTY_FAILED:
        case types_2.ActionTypes.REMOVE_LOYALTY_FAILED:
            return Object.assign(Object.assign(Object.assign({}, state), action.payload), { newError: true });
        default:
            return Object.assign(Object.assign(Object.assign({}, state), action.payload), { error: {} });
    }
}
exports.reducer = reducer;
